import { render, staticRenderFns } from "./AppCredenciar.vue?vue&type=template&id=35c43afa&scoped=true&lang=pug&"
import script from "./AppCredenciar.vue?vue&type=script&lang=js&"
export * from "./AppCredenciar.vue?vue&type=script&lang=js&"
import style0 from "./AppCredenciar.vue?vue&type=style&index=0&id=35c43afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c43afa",
  null
  
)

export default component.exports